export default __webpack_public_path__ + "static/media/change.46d2d1e3.svg";